import React from "react"

function StepB() {
  return (
    <svg viewBox="0 0 266 150" fill="none">
      <path fill="var(--solid)" d="M0 0h266v150H0z" />
      <path d="M78 41v-1h110v1H78z" fill="var(--base-400)" />
      <path stroke="var(--main-500)" d="M78 40.5h28" />
      <path
        d="M78 31a2 2 0 012-2h24a2 2 0 012 2v9H78v-9z"
        fill="var(--main-100)"
      />
      <path
        d="M82 35a1 1 0 011-1h18a1 1 0 010 2H83a1 1 0 01-1-1z"
        fill="var(--main-500)"
      />
      <path
        d="M112 35a1 1 0 011-1h18a1 1 0 010 2h-18a1 1 0 01-1-1zM138 35a1 1 0 011-1h18a1 1 0 010 2h-18a1 1 0 01-1-1zM164 35a1 1 0 011-1h18a1 1 0 010 2h-18a1 1 0 01-1-1z"
        fill="var(--solid-900)"
      />
      <path
        d="M122.889 87h20.222A2.889 2.889 0 00146 84.111V63.89a2.889 2.889 0 00-2.889-2.89h-20.222A2.889 2.889 0 00120 63.889V84.11a2.889 2.889 0 002.889 2.89zm0 0l15.889-15.889L146 78.333m-15.889-9.389a2.167 2.167 0 11-4.333 0 2.167 2.167 0 014.333 0z"
        stroke="var(--base-500)"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M85 111.5a1.5 1.5 0 011.5-1.5h93a1.5 1.5 0 010 3h-93a1.5 1.5 0 01-1.5-1.5zM80 118.5a1.5 1.5 0 011.5-1.5h104a1.5 1.5 0 010 3h-104a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--base-500)"
      />
      <rect
        x={100}
        y={101}
        width={67}
        height={4}
        rx={2}
        fill="var(--solid-900)"
      />
    </svg>
  )
}

export default StepB;
